import React, { Component } from 'react';
import { upgradeMdl } from '../../utils';

export class Loading extends Component {

  static style = {
    width: '80px',
    height: '80px',
  }

  componentDidMount() {
    upgradeMdl();
  }

  render() {
    return (
      <div style={Loading.style} className="mdl-spinner mdl-js-spinner is-active"></div>
    );
  }
};
